import { createContext } from 'react';
import { SourcePages } from 'lib/EventSchema';

export default createContext<{
  sourcePage: SourcePages;
}>({
  sourcePage: SourcePages.Vdp,
});
